import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { notNil } from '../../core/helpers/is-nil';
import { SectionHeaderTitle } from '../section-header-title/section-header-title';
import styles from './section-header.module.scss';

type Props = {
  children: ReactNode;
  button?: ReactNode;
  ref?: React.Ref<HTMLDivElement>;
};

export const SectionHeader: React.FC<Props> = ({ children, button, ref }) => {
  const hasButton = notNil(button);
  return (
    <div ref={ref} className={classNames(styles.root, { [styles.withButton]: hasButton })}>
      <SectionHeaderTitle>{children}</SectionHeaderTitle>
      {button}
    </div>
  );
};
